import React from 'react'

import Icon from '../../Icon/index.tsx'


const ExpandMoreIcon = props => {
  return (
    <Icon {...props}>
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/>
    </Icon>
  )
}

export default ExpandMoreIcon